import type { UiSettingsProvider } from './UiSettings';
import { inject } from 'vue';

export function useUiSettings() {
  return inject('uiSettings')! as UiSettingsProvider;
}
